import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, withRouter } from 'react-router-dom';
import qs from 'query-string';

const UnauthenticatedRoute = ({
    component: C,
    props: cProps,
    location,
    ...rest
}) => {
    const query = qs.parse(location.search);
    const redirect = query.redirect || null;

    return (
        <Route
            {...rest}
            render={props =>
                !cProps.isAuthenticated ? (
                    <C {...props} {...cProps} />
                ) : (
                    <Redirect
                        to={
                            redirect === '' || redirect === null
                                ? '/'
                                : redirect
                        }
                    />
                )
            }
        />
    );
};

UnauthenticatedRoute.propTypes = {
    component: PropTypes.func.isRequired,
    props: PropTypes.shape().isRequired,
    location: PropTypes.shape({
        search: PropTypes.string
    }).isRequired
};

export default withRouter(UnauthenticatedRoute);
